export const AdminMenus = [
  {
    label: "Dashboard",
    key: "dashboard",
    icon: "ki-outline ki-element-11",
  },
  {
    label: "Manage User",
    key: "manage-user",
    icon: "ki-outline ki-profile-user ",
  },

];
